'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AskQuestion } from '@/src/components/AskQuestion';
import { Footertop } from '@/src/components/Footertop';
import i18n from '@/src/i18n';
import { sendAnalyticsData } from '@/src/utils/analytics';
import { ChooseLang } from '../../ChooseLang';
import { NoTutorialFound } from '../NoTutorialFound';
import { TutorialItem } from '../TutorialItem';
interface ITutorialItem {
  videoUrl: string;
  bgColor: string;
  bgImage: string;
  title: string;
}

// trigger-build
export const Tutorial = () => {
  const $ = _c(30);
  const [clickedIndex, setClickedIndex] = useState(-1);
  const [searchTerm, setSearchTerm] = useState("");
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== searchTerm) {
    const tutorials = [{
      title: i18n.t("How to take data in AbleSpace?"),
      bgImage: "/images/icons/tutorials/tutorial-1.webp",
      videoUrl: i18n.t("xn9z5OsMrnI"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to add a student to your caseload?"),
      bgImage: "/images/icons/tutorials/tutorial-2.webp",
      videoUrl: i18n.t("FTq64d-cL9U"),
      bgColor: "bg-[#D9E8EF]"
    }, {
      title: i18n.t("How to add a Goal?"),
      bgImage: "/images/icons/tutorials/tutorial-3.webp",
      videoUrl: i18n.t("ZM9eORYl6Rk"),
      bgColor: "bg-[#FAFFC3]"
    }, {
      title: i18n.t("How to add a note?"),
      bgImage: "/images/icons/tutorials/tutorial-4.webp",
      videoUrl: i18n.t("vNv45p93zTs"),
      bgColor: "bg-[#D1FDF0]"
    }, {
      title: i18n.t("How to take or create an assessment?"),
      bgImage: "/images/icons/tutorials/tutorial-5.webp",
      videoUrl: i18n.t("Lk98hzNyQZI"),
      bgColor: "bg-[#FDD9D9]"
    }, {
      title: i18n.t("How to generate a Report?"),
      bgImage: "/images/icons/tutorials/tutorial-7.webp",
      videoUrl: i18n.t("0uuFFkfXYAY"),
      bgColor: "bg-[#FAFFC3]"
    }, {
      title: i18n.t("How to create a session?"),
      bgImage: "/images/icons/tutorials/tutorial-8.webp",
      videoUrl: i18n.t("nxvw6LaEm1w"),
      bgColor: "bg-[#D9F8CB]"
    }, {
      title: i18n.t("How to bulk-add students?"),
      bgImage: "/images/icons/tutorials/tutorial-9.webp",
      videoUrl: i18n.t("LIIjEvO2faE"),
      bgColor: "bg-[#D0C0E5]"
    }, {
      title: i18n.t("How to generate Billing Notes?"),
      bgImage: "/images/icons/tutorials/tutorial-10.webp",
      videoUrl: i18n.t("6UfEEfX6l4w"),
      bgColor: "bg-[#FFC3D8]"
    }, {
      title: i18n.t("Refer and Earn in AbleSpace"),
      bgImage: "/images/icons/tutorials/tutorial-11.webp",
      videoUrl: "OSQUieDSstI",
      bgColor: "bg-[#D1FDF0]"
    }, {
      title: i18n.t("How to enter data in Past Sessions?"),
      bgImage: "/images/icons/tutorials/tutorial-13.webp",
      videoUrl: i18n.t("BKT8N91WFn4"),
      bgColor: "bg-[#FDD9D9]"
    }, {
      title: i18n.t("How to bulk add Goals?"),
      bgImage: "/images/icons/tutorials/tutorial-14.webp",
      videoUrl: i18n.t("ZSqlSiVl5GI"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to track services?"),
      bgImage: "/images/icons/tutorials/tutorial-15.webp",
      videoUrl: i18n.t("OnVtLozuX2E"),
      bgColor: "bg-[#D0C0E5]"
    }, {
      title: i18n.t("How to add filters to the calendar?"),
      bgImage: "/images/icons/tutorials/tutorial-16.webp",
      videoUrl: i18n.t("eKtLM9iBRQc"),
      bgColor: "bg-[#D9F8CB]"
    }, {
      title: i18n.t("How to mark all students absent in an event?"),
      bgImage: "/images/icons/tutorials/tutorial-17.webp",
      videoUrl: i18n.t("G4gLE6nwknA"),
      bgColor: "bg-[#FFC3D8]"
    }, {
      title: i18n.t("How to manage Assistant\u2019s Calendar?"),
      bgImage: "/images/icons/tutorials/tutorial-18.webp",
      videoUrl: i18n.t("nHfBZoh6wHw"),
      bgColor: "bg-[#FAFFC3]"
    }, {
      title: i18n.t("How to Download & Print Caseload?"),
      bgImage: "/images/icons/tutorials/tutorial-19.webp",
      videoUrl: i18n.t("3DLKoF0cs8o"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to Auto-Copy Goals?"),
      bgImage: "/images/icons/tutorials/tutorial-20.webp",
      videoUrl: i18n.t("kkJS15zOKIQ"),
      bgColor: "bg-[#D1FDF0]"
    }, {
      title: i18n.t("How to add custom field to students details?"),
      bgImage: "/images/icons/tutorials/tutorial-21.webp",
      videoUrl: i18n.t("MUb29EKgMD8"),
      bgColor: "bg-[#FDD9D9]"
    }, {
      title: i18n.t("How to create and manage groups?"),
      bgImage: "/images/icons/tutorials/tutorial-22.webp",
      videoUrl: i18n.t("AB0J1N0WLss"),
      bgColor: "bg-[#FFC3D8]"
    }, {
      title: i18n.t("How to transfer students to another user?"),
      bgImage: "/images/icons/tutorials/tutorial-23.webp",
      videoUrl: i18n.t("LaguppFh2Yc"),
      bgColor: "bg-[#D9E8EF]"
    }, {
      title: i18n.t("How to view graphs for goal progress?"),
      bgImage: "/images/icons/tutorials/tutorial-24.webp",
      videoUrl: i18n.t("4rvZCFTWC3c"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to archive goals?"),
      bgImage: "/images/icons/tutorials/tutorial-25.webp",
      videoUrl: i18n.t("qkcrtya5UPc"),
      bgColor: "bg-[#D9F8CB]"
    }, {
      title: i18n.t("How to Copy Goals?"),
      bgImage: "/images/icons/tutorials/tutorial-26.webp",
      videoUrl: i18n.t("06idxHvLHf8"),
      bgColor: "bg-[#FAFFC3]"
    }, {
      title: i18n.t("How to Create and Use Labels in Goals?"),
      bgImage: "/images/icons/tutorials/tutorial-27.webp",
      videoUrl: i18n.t("w5X8SWLLk-w"),
      bgColor: "bg-[#D0C0E5]"
    }, {
      title: i18n.t("How to generate a Session Report?"),
      bgImage: "/images/icons/tutorials/tutorial-28.webp",
      videoUrl: i18n.t("-rwLIyQzvSY"),
      bgColor: "bg-[#D9E8EF]"
    }, {
      title: i18n.t("How to mark attendance?"),
      bgImage: "/images/icons/tutorials/tutorial-29.webp",
      videoUrl: i18n.t("yk9S-bePjKU"),
      bgColor: "bg-[#FFC3D8]"
    }, {
      title: i18n.t("How to archive students?"),
      bgImage: "/images/icons/tutorials/tutorial-30.webp",
      videoUrl: i18n.t("MzfJPGmDy0A"),
      bgColor: "bg-[#D1FDF0]"
    }, {
      title: i18n.t("How to use the Advanced Options?"),
      bgImage: "/images/icons/tutorials/tutorial-32.webp",
      videoUrl: i18n.t("Gm-D_PKNYOk"),
      bgColor: "bg-[#D1FDF0]"
    }, {
      title: i18n.t("How to collaborate with your team?"),
      bgImage: "/images/icons/tutorials/tutorial-33.webp",
      videoUrl: i18n.t("hZpfRTzd0j0"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to open multiple events simultaneously?"),
      bgImage: "/images/icons/tutorials/tutorial-34.webp",
      videoUrl: i18n.t("v2fs1Z5y4oY"),
      bgColor: "bg-[#FFC3D8]"
    }, {
      title: i18n.t("How to manage calendar preferences?"),
      bgImage: "/images/icons/tutorials/tutorial-35.webp",
      videoUrl: i18n.t("gNCDzuZgnu0"),
      bgColor: "bg-[#D9F8CB]"
    }, {
      title: i18n.t("How to Reorder & Renumber the goals?"),
      bgImage: "/images/icons/tutorials/tutorial-36.webp",
      videoUrl: i18n.t("oESW1fjjyjI"),
      bgColor: "bg-[#D9E8EF]"
    }, {
      title: i18n.t("How to use AbleSpace AI features?"),
      bgImage: "/images/icons/tutorials/tutorial-37.webp",
      videoUrl: i18n.t("HeYIduT0exQ"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to use Phases?"),
      bgImage: "/images/icons/tutorials/tutorial-38.webp",
      videoUrl: i18n.t("j_nZvLzfs6U"),
      bgColor: "bg-[#D0C0E5]"
    }, {
      title: i18n.t("How to use Accommodations?"),
      bgImage: "/images/icons/tutorials/tutorial-39.webp",
      videoUrl: i18n.t("ZPnjf9ZfZ-c"),
      bgColor: "bg-[#FAFFC3]"
    }, {
      title: i18n.t("How to use Admin Dashboard to share students?"),
      bgImage: "/images/icons/tutorials/tutorial-40.webp",
      videoUrl: i18n.t("psW6cHt0FOE"),
      bgColor: "bg-[#D1FDF0]"
    }, {
      title: i18n.t("How to log your data quickly using Data tab?"),
      bgImage: "/images/icons/tutorials/tutorial-41.webp",
      videoUrl: i18n.t("ygI2jZKMojc"),
      bgColor: "bg-[#FFC3D8]"
    }, {
      title: i18n.t("How to create and implement a Rotating Schedule?"),
      bgImage: "/images/icons/tutorials/tutorial-42.webp",
      videoUrl: i18n.t("AGn9737WBSY"),
      bgColor: "bg-[#D9F8CB]"
    }, {
      title: i18n.t("How to Generate Progress Notes using AbleSpace AI?"),
      bgImage: "/images/icons/tutorials/tutorial-43.webp",
      videoUrl: i18n.t("J4naLxGHxEY"),
      bgColor: "bg-[#FDD9D9]"
    }, {
      title: i18n.t("How to Enhance Notes with AbleSpace AI?"),
      bgImage: "/images/icons/tutorials/tutorial-44.webp",
      videoUrl: i18n.t("0exFOj-PXoE"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("Suggest Data Tracking Templates with AbleSpace AI"),
      bgImage: "/images/icons/tutorials/tutorial-45.webp",
      videoUrl: i18n.t("X2FOFmZcsIk"),
      bgColor: "bg-[#D0C0E5]"
    }, {
      title: i18n.t("How to use Advanced Graph Options?"),
      bgImage: "/images/icons/tutorials/tutorial-46.webp",
      videoUrl: i18n.t("WvICW8PkT4c"),
      bgColor: "bg-[#D9F8CB]"
    }, {
      title: i18n.t("Using Calendar & Calendar Preferences"),
      bgImage: "/images/icons/tutorials/tutorial-47.webp",
      videoUrl: i18n.t("kkfUXID8RD8"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to use Custom Data Type?"),
      bgImage: "/images/icons/tutorials/tutorial-48.webp",
      videoUrl: i18n.t("jQOfz1f8tug"),
      bgColor: "bg-[#FFC3D8]"
    }, {
      title: i18n.t("How to use Rubrics Data Type?"),
      bgImage: "/images/icons/tutorials/tutorial-49.webp",
      videoUrl: i18n.t("huLxd8askZY"),
      bgColor: "bg-[#D9E8EF]"
    }, {
      title: i18n.t("How to generate worksheets?"),
      bgImage: "/images/icons/tutorials/tutorial-50.webp",
      videoUrl: i18n.t("hSfA7DkD23k"),
      bgColor: "bg-[#D1FDF0]"
    }, {
      title: i18n.t("How to use various Measurement Types for tracking Goals?"),
      bgImage: "/images/icons/tutorials/tutorial-51.webp",
      videoUrl: i18n.t("LKqSEW3-zSw"),
      bgColor: "bg-[#FAFFC3]"
    }, {
      title: i18n.t("How to Communicate with Parents?"),
      bgImage: "/images/icons/tutorials/tutorial-52.webp",
      videoUrl: i18n.t("n6WmwxPsTs4"),
      bgColor: "bg-[#A0DCFF]"
    }, {
      title: i18n.t("How to use Partial and Whole Interval?"),
      bgImage: "/images/icons/tutorials/tutorial-53.webp",
      videoUrl: i18n.t("pE7mN_mbpUs"),
      bgColor: "bg-[#D0C0E5]"
    }];
    t0 = tutorials.filter(tutorial => tutorial.title.toLowerCase().includes(searchTerm.toLowerCase()));
    $[0] = searchTerm;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const filteredTutorials = t0;
  let t1;
  if ($[2] !== t) {
    t1 = t("Tutorials and Videos");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="pb-8 text-3xl font-medium text-[#3D3E40] md:text-center md:text-4xl">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="absolute inset-y-0 left-0 flex items-center pl-3"><Image src="/images/MagnifyingGlass.svg" alt="Search Icon" width={20} height={20} /></span>;
    t4 = i18n.t("Search here...");
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => {
      setSearchTerm(e.target.value);
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== searchTerm) {
    t6 = <div className="relative w-[90%] md:w-[50%]">{t3}<input placeholder={t4} type="text" value={searchTerm} onClick={_temp} onChange={t5} className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-4" /></div>;
    $[9] = searchTerm;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute right-0 top-4 hidden lg:block"><ChooseLang isHeader={false} /></div>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <div className="relative flex items-center justify-center py-4">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== filteredTutorials.length || $[15] !== searchTerm || $[16] !== t) {
    t9 = searchTerm && filteredTutorials.length > 0 ? <div className="mt-4 pb-3 text-center text-lg font-normal text-gray-900">{filteredTutorials.length}{" "}{t(`result${filteredTutorials.length !== 1 ? "s" : ""}`)}{" "}{t("found for")} ‘{searchTerm}’</div> : searchTerm && <NoTutorialFound onBrowseAll={() => setSearchTerm("")} />;
    $[14] = filteredTutorials.length;
    $[15] = searchTerm;
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== clickedIndex || $[19] !== filteredTutorials) {
    t10 = filteredTutorials.length > 0 && <div className="mt-4 grid grid-cols-1 gap-x-20 gap-y-8 pt-8 md:grid-cols-2 md:gap-y-12 lg:grid-cols-3">{filteredTutorials.map((tutorial_0, index) => <TutorialItem data={tutorial_0} key={index} index={index} clickedIndex={clickedIndex} videoHandler={i => setClickedIndex(i)} />)}</div>;
    $[18] = clickedIndex;
    $[19] = filteredTutorials;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="mt-10 md:mt-28 xl:px-52"><AskQuestion /></div>;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t2 || $[24] !== t8 || $[25] !== t9) {
    t12 = <div className="container mx-auto px-12 py-8 md:p-16 2xl:px-24">{t2}{t8}{t9}{t10}{t11}</div>;
    $[22] = t10;
    $[23] = t2;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Footertop />;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t12) {
    t14 = <div className="mt-20">{t12}{t13}</div>;
    $[28] = t12;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
function _temp() {
  sendAnalyticsData("TUTORIAL_SEARCH_INPUT_CLICKED");
}